module.exports = __webpack_public_path__ + "media/images/how-img-1152-f4ea85cd43cda643929e311528f25d74.png";